// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M3 3H21V21H3V3Z","strokeWidth":"props.strokeWidth","fill":"none"}},{"tag":"g","attrs":{},"children":[{"tag":"path","attrs":{"stroke":"#000","d":"M7 7H9V9H7V7Z M11 11H13V13H11V11Z M7 15H9V17H7V15Z M15 7H17V9H15V7Z M15 15H17V17H15V15Z","strokeWidth":"props.strokeWidth","fill":"none"}}]}]}]},{"tag":"g","attrs":{"id":"mosaic"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V21H3V3Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21V21H3V3Z","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M7 7H9V9H7V7Z M11 11H13V13H11V11Z M7 15H9V17H7V15Z M15 7H17V9H15V7Z M15 15H17V17H15V15Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const MosaicIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mosaic',
    ref,
    icon: element,
  },
));

MosaicIcon.displayName = 'MosaicIcon';

export default MosaicIcon;
